import { pxToRem } from '@modernhealth/vital-components';
import React, { FC } from 'react';
import styled from '@emotion/styled';

export const ScreenContainer: FC = ({ children }) => {
    return <Container>{children}</Container>;
};

const Container = styled.div({
    width: pxToRem(500),
    maxWidth: pxToRem(500),
});
